import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import type { ContributionView } from '~/state/useContributionView'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  view: ContributionView
  onSwitch: (next: ContributionView) => void
}

/** The merged Contribution page's view switch (#13): Media-channels ↔ Driver-groups
 *  decomposition presets. Pure presentational; the URL/preset semantics live in
 *  useContributionView. */
export function ContributionViewToggle({ view, onSwitch }: Props) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={view}
      // MUI fires null when the active button is re-clicked — keep the view (never empty).
      onChange={(_, next: ContributionView | null) => {
        if (next !== null) onSwitch(next)
      }}
      aria-label={CONTROLS.contributionViewAria}
    >
      <ToggleButton value="channels">{CONTROLS.mediaChannels}</ToggleButton>
      <ToggleButton value="groups">{CONTROLS.driverGroups}</ToggleButton>
    </ToggleButtonGroup>
  )
}
